import { Col, Form } from "react-bootstrap";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";

function BirthDay({ value, setField, errors, label }) {
  return (
    <Col xs={12} md={6}>
      <Form.Label>
        <span>{label}</span>
        <span className="text-danger">*</span>
      </Form.Label>

      <DatePicker
        calendar={persian}
        locale={persian_fa}
        value={value}
        style={{ width: "100%", height: "2.2rem" }}
        onChange={e => {
          if (e === null) {
            setField("birthDay", undefined);
            return;
          }
          setField("birthDay", e.year + "/" + e.month.number + "/" + e.day);
        }}
      />
      {errors.birthDay !== undefined && (
        <p className="m-0 text-danger" style={{ fontSize: "14px" }}>
          {errors.birthDay}
        </p>
      )}
    </Col>
  );
}

export default BirthDay;
